var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.58,
    height: 103.65,
    viewBox: "0 0 96.58 103.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "review",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106168",
    "data-name": "Group 106168",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69826",
    "data-name": "Path 69826",
    d: "M90.231,20.679a1.788,1.788,0,0,0-1.465,2.061A41.177,41.177,0,0,1,74.677,61.158,26.6,26.6,0,0,0,56.129,39.712a14.308,14.308,0,1,0-15.832,0A26.6,26.6,0,0,0,21.749,61.158,41.177,41.177,0,0,1,7.66,22.74a1.789,1.789,0,1,0-3.528-.594A44.653,44.653,0,0,0,40.8,73.677a1.677,1.677,0,0,0,.293.024,1.788,1.788,0,0,0,.29-3.553A40.966,40.966,0,0,1,25.07,63.641a23.2,23.2,0,0,1,46.285,0A40.966,40.966,0,0,1,55.04,70.149a1.788,1.788,0,0,0,.29,3.553,1.677,1.677,0,0,0,.293-.024,44.653,44.653,0,0,0,36.67-51.532A1.78,1.78,0,0,0,90.231,20.679Zm-52.749,7.13A10.731,10.731,0,1,1,48.213,38.539,10.743,10.743,0,0,1,37.482,27.808Z",
    transform: "translate(0.077 29.341)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69827",
    "data-name": "Path 69827",
    d: "M49.76,15.671a1.788,1.788,0,0,0-1.444-1.219L36.888,12.793,31.777,2.435a1.866,1.866,0,0,0-3.207,0L23.46,12.793,12.032,14.452A1.791,1.791,0,0,0,11.04,17.5l8.27,8.059L17.357,36.945a1.789,1.789,0,0,0,2.6,1.886l10.221-5.376,10.221,5.376a1.766,1.766,0,0,0,.833.206,1.789,1.789,0,0,0,1.762-2.092L41.038,25.564l8.27-8.059A1.792,1.792,0,0,0,49.76,15.671ZM37.867,23.656a1.793,1.793,0,0,0-.514,1.586l1.5,8.737-7.846-4.125a1.787,1.787,0,0,0-1.666,0l-7.846,4.125,1.5-8.737a1.793,1.793,0,0,0-.514-1.586l-6.347-6.183L24.9,16.2a1.793,1.793,0,0,0,1.347-.978L30.174,7.27,34.1,15.22a1.793,1.793,0,0,0,1.347.978l8.771,1.275Z",
    transform: "translate(18.116 -1.523)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69828",
    "data-name": "Path 69828",
    d: "M7.991,34.14a1.789,1.789,0,0,0,2.6,1.886l8.01-4.213,8.01,4.213a1.766,1.766,0,0,0,.833.206A1.789,1.789,0,0,0,29.2,34.14l-1.53-8.918,6.482-6.316a1.791,1.791,0,0,0-.992-3.053l-8.957-1.3-4-8.118a1.866,1.866,0,0,0-3.207,0l-4,8.118-8.957,1.3a1.791,1.791,0,0,0-.992,3.053l6.482,6.316Zm.141-15.265,6.3-.915a1.793,1.793,0,0,0,1.347-.978L18.6,11.27l2.817,5.711a1.793,1.793,0,0,0,1.347.978l6.3.915L24.5,23.314a1.793,1.793,0,0,0-.514,1.586l1.076,6.274L19.43,28.212a1.787,1.787,0,0,0-1.666,0l-5.635,2.962L13.2,24.9a1.793,1.793,0,0,0-.514-1.586Z",
    transform: "translate(-2.5 8.785)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69829",
    "data-name": "Path 69829",
    d: "M51.162,15.853l-8.957-1.3-4-8.118a1.866,1.866,0,0,0-3.207,0l-4,8.118-8.957,1.3a1.791,1.791,0,0,0-.992,3.053l6.482,6.316-1.53,8.918a1.789,1.789,0,0,0,2.6,1.886l8.01-4.213,8.01,4.213a1.766,1.766,0,0,0,.833.206A1.789,1.789,0,0,0,47.2,34.14l-1.53-8.918,6.482-6.316a1.791,1.791,0,0,0-.992-3.053ZM42.5,23.314a1.793,1.793,0,0,0-.514,1.586l1.076,6.274L37.43,28.212a1.787,1.787,0,0,0-1.666,0l-5.635,2.962L31.2,24.9a1.793,1.793,0,0,0-.514-1.586l-4.559-4.44,6.3-.915a1.793,1.793,0,0,0,1.347-.978L36.6,11.27l2.817,5.711a1.793,1.793,0,0,0,1.347.978l6.3.915Z",
    transform: "translate(43.887 8.785)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9618",
    "data-name": "Ellipse 9618",
    cx: 1.789,
    cy: 1.789,
    r: 1.789,
    transform: "translate(46.501 100.073)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.7978c09bced47491b70fae07d2843339.svg";
export { ForwardRef as ReactComponent };